import moment from 'moment'

export const disabledAppointmentDates = (date: moment.Moment) => {
  if (!date) {
    return
  }

  return date.isBefore(moment(), 'day')
}
